import { render, staticRenderFns } from "./CardInfoNfe.vue?vue&type=template&id=13e77bc8&scoped=true&"
import script from "./CardInfoNfe.vue?vue&type=script&lang=js&"
export * from "./CardInfoNfe.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoNfe.vue?vue&type=style&index=0&id=13e77bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e77bc8",
  null
  
)

export default component.exports